import React from 'react';

const IconWrapper = ({ icon: Icon, ...props }) => {
    return <Icon {...props} />
};

export default IconWrapper;
